import { useFormatMsg } from "src/hooks/useFormatMsg";
import { TableCellValue } from "src/requests/table/types";

type GetEntriesBtnMessage = (
  cellValues: TableCellValue[],
  notNullValues: TableCellValue[],
  editable: boolean
) => string;

// eslint-disable-next-line import/prefer-default-export
export const useGetEntriesBtnMessage = (): GetEntriesBtnMessage => {
  const formatMsg = useFormatMsg();

  const getEntriesBtnMessage: GetEntriesBtnMessage = (
    cellValues,
    notNullValues,
    editable
  ) => {
    // tohle je potreba, protoze pokud je hodnota null tak prijde ze serveru jako [null], coz neprojde klasickou asserci na null
    if (!cellValues.length || (cellValues.length === 1 && !cellValues[0])) {
      return formatMsg("table.add_entry");
    }

    const entriesNumber = editable ? cellValues.length : notNullValues.length;

    return formatMsg("table.more_entries", {
      entries: entriesNumber,
    });
  };

  return getEntriesBtnMessage;
};

export const getArrayValuesFromValue = (
  value: TableCellValue
): TableCellValue[] => {
  if (!value) return [];

  if (Array.isArray(value)) return [...value];

  return [];
};
